<header class="header">
      <div class="header-grp">
          <div class="icon" (click)="goBackToPrevPage()">
              <i class="ti ti-chevron-left"></i>
          </div>
          <div class="title">
              <h3 *ngIf="action == 'Add'">કાર્યક્રમ ઉમેરો</h3>
              <h3 *ngIf="action ==  'Edit'">કાર્યક્રમ બદલો</h3>
          </div>
      </div>
  </header>
  <main>
      <div class="loginWraper">
          <form [formGroup]="eventForm">
              <div class="form-group">
                  <div class="row">
                      <div class="col-md-12">
                          <input type="text" class="form-control" placeholder="કાર્યક્રમ" formControlName="event_name" />
                          <div *ngIf="submitted && f.event_name.errors" class="error-message">
                              <small *ngIf="f.event_name.errors?.required" class="text-danger">કાર્યક્રમ નામ જરૂરી
                                  છે.</small>
                          </div>
                      </div>
                  </div>
              </div>
              <button type="submit" class="btn-common" (click)="submit()">સાચવો</button>
          </form>
      </div>
  </main>